<template>

  <div class="page">

    <Head></Head>
    <scenePc v-if="!isPhone"></scenePc>
    <sceneMobile v-if="isPhone"></sceneMobile>
    <Foot></Foot>
  </div>
</template>

<script>
import Head from "../../components/header-index.vue";
import Foot from "../../components/footer-index.vue";
import sceneMobile from "./sceneMobile.vue";
import scenePc from "./scenePc.vue";

export default {
  components: {
    Head,
    Foot,
    scenePc,
    sceneMobile
  },
  data() {
    return {
      isPhone: false
    };
  },
  created() {
    // 判断是否手机
    this.getIsPhone();
    // 设置标题
    this.setTitle();
  },
  methods: {
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }
    },
    setTitle() {
      document.title = "ESG专题";
    }
  }
};
</script>

<style scoped>
/deep/ul{
  list-style: none;
  padding-left: 0;
}
</style>
